import * as React from 'react'

import { Text, TextName } from 'sdk'
import GradientOutlineGridBackgroundCard from 'components/gradient-outline-grid-background-card/GradientOutlineGridBackgroundCard'
import BlueGridContainer from 'components/blue-grid-container/BlueGridContainer'
import { OutlineGlassBackgroundCard } from 'components/outline-glass-background-card/OutlineGlassBackgroundCard'

import type { ResourcesPartnerProgramCmsContent } from 'core/services/cms/interfaces'

import classes from './PartnerProgramSection.module.scss'

interface PartnerProgramSectionProps {
  content: ResourcesPartnerProgramCmsContent
}

export const PartnerProgramSection: React.FC<PartnerProgramSectionProps> = ({ content }) => {
  return (
    <section className={classes.wrapper}>
      <Text type={TextName.H2}>{content.title}</Text>
      <Text type={TextName.Text}>{content.description}</Text>

      <div className={classes.cardsContainer}>
        {content.partners.map((partner) => (
          <GradientOutlineGridBackgroundCard key={partner.title} className={classes.card}>
            <div className={classes.cardHeader}>
              <img src={partner.iconUrl} alt='' className={classes.icon} />
              <Text type={TextName.H3}>{partner.title}</Text>
            </div>
            <Text type={TextName.Text}>{partner.description}</Text>
          </GradientOutlineGridBackgroundCard>
        ))}
      </div>

      <BlueGridContainer className={classes.benefitsContainer}>
        <Text type={TextName.H3}>{content.benefitsTitle}</Text>
        <div className={classes.benefitsCardsContainer}>
          {content.benefits.map((benefit) => (
            <OutlineGlassBackgroundCard key={benefit.text} className={classes.benefitCard}>
              <img src={benefit.iconUrl} alt='' className={classes.benefitIcon} />
              <Text type={TextName.Text}>{benefit.text}</Text>
            </OutlineGlassBackgroundCard>
          ))}
        </div>
      </BlueGridContainer>
    </section>
  )
}
